import React from 'react'
import ContentBox from '../../../layout/component/ContentBox'
import Column from '../../../bootstrap/component/Column'
import Row from '../../../bootstrap/component/Row'
import currentUserHasAccess from '../../../../util/widget-helper'
import { TREATMENT_VISUALIZATION_WIDGET_CONTAINER } from '../../../process/ui-definition/process-ui'
import PropTypes from "prop-types";


const VISUALIZATION_LINK = 'https://sunshinesmile.de/visualization/?quality=medium&showGridButton=true&id='

const style = {
    width: '100%',
    height: '600px',
    border: '0',
}

const TreatmentVisualizationWidget = ({ treatmentQuotation, treatmentPlan, readOnly }) => {
    if (!currentUserHasAccess(TREATMENT_VISUALIZATION_WIDGET_CONTAINER)) {
        return null
    }

    if (!treatmentQuotation || !treatmentPlan) {
        return null
    }

    const alignerSystem = treatmentPlan.system
    const link = treatmentQuotation.visualizationId ? VISUALIZATION_LINK + treatmentQuotation.visualizationId + '&system=' + alignerSystem : treatmentQuotation.treatmentLink

    return (
        <ContentBox title="Treatment Visualization">
            <Row>
                <Column size={12}>
                    <a href={link} target="_blank" rel="noopener noreferrer">Open in new Window</a>
                    <iframe style={style} src={link} title="preview"/>
                </Column>
            </Row>
        </ContentBox>
    )
}

TreatmentVisualizationWidget.propTypes = {
    treatmentQuotation: PropTypes.object,
    treatmentPlan: PropTypes.object,
}

export default TreatmentVisualizationWidget



// WEBPACK FOOTER //
// ./src/modules/treatment/component/task-widget/TreatmentVisualizationWidget.js